import { NotificationMenu, Text } from '@bbl-digital/snorre-v2'
import { useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { IBellNotificationPayload, ISocketMessage } from 'shared/models/Socket'
import { setClientById } from 'shared/store/clients/actions'
import { getActiveClientId, getClients } from 'shared/store/clients/selectors'
import { markNotificationAsRead } from 'shared/store/notifications'
import { getNotificationUrl, notificationDescriptions } from '../helpers'

type Props = {
  hideBorderBottom: boolean
  triggerClose: () => void
}

const NotificationItem = ({
  NotificationType,
  Notification,
  id,
  hideBorderBottom,
  triggerClose,
}: Props & ISocketMessage<IBellNotificationPayload>) => {
  const dispatch = useDispatch()
  const activeClientId = useSelector(getActiveClientId)
  const clients = useSelector(getClients)
  const { push } = useHistory()

  const notificationClient = useMemo(() => {
    if (clients.length <= 1) return
    if (!Notification.Payload?.ClientId) return

    return clients.find((x) => x.id === Notification.Payload.ClientId)
  }, [clients, Notification.Payload?.ClientId])

  const handleClick = async () => {
    if (activeClientId !== Notification.Payload.ClientId)
      await dispatch(setClientById(Notification.Payload.ClientId))

    push(getNotificationUrl(NotificationType, Notification.Payload))
    triggerClose()

    dispatch(markNotificationAsRead(id))
  }

  const description = useMemo(() => {
    return (
      Notification?.Payload?.Description ||
      notificationDescriptions[NotificationType] ||
      ''
    )
  }, [Notification, NotificationType])

  return (
    <NotificationMenu.Item
      closeOnSelect
      notification={Notification.Payload}
      key={id}
      isLast={hideBorderBottom}
      onClick={handleClick}
    >
      <div className="flex items-center justify-between w-full">
        <div className="flex items-center gap-md text-text-brand">
          <div className="flex flex-col items-start text-left">
            {Notification.Payload.Title && (
              <Text variant="small" weight="semibold">
                {Notification.Payload.Title}
              </Text>
            )}
            {Notification.Payload.Description && (
              <Text variant="small">{description}</Text>
            )}
            {notificationClient?.name && (
              <Text variant="small" subtle>
                {notificationClient.name}
              </Text>
            )}
          </div>
        </div>
      </div>
    </NotificationMenu.Item>
  )
}

export default NotificationItem
